import { Ref } from "vue";

export interface SlideContent {
    imageSrc?: string;
    contentText: string;
    audioSrc?: string;
}

export enum FileIdentifiers {
    Audio = "$D1@-",
    Pdf = "$D2@-",
    JourneySet = "$D3@-",
    Apk = "$D4@-"
}

export enum MimeTypes {
    APK = 'application/vnd.android.package-archive',
    AUDIO = 'audio/mpeg',
    TEXT = 'text/plain',
    URL = 'text/x-uri',
    PDF = 'application/pdf',
    JSON = "application/json"
}

export interface ChipletButton {
    icon?: string;
    src?: string; // For SVG icons
    label?: string; // retrieved from language file keys
    name?: string; //used to filter and order arrays of these buttons
    visibilityClass: string;
    fileInputRef?: Ref<HTMLInputElement | null>; // Reference to file input element
    handler: () => void;
}
